<template>
  <v-app>
    <v-container v-if="ordListDetail == false" style="padding:0px;">
      <div v-if="emptyOrderListHistory == false">
        <div class="col-xs-12" style="margin-bottom: 30px;">
          <v-card
            v-for="OrdList in ListOfOrderListHistory"
            :key="OrdList.ID"
            class="list-group-item clearfix"
            style="margin:10px;border-radius:15px;"
            @click="viewOrder(OrdList.oa)"
          >
            <div class="col-xs-12 pull-left" style="padding: 0px;">
              <h5 class="list-group-item-text ordListTxt">{{$t('OrderID')}}: {{ OrdList.oa }}</h5>
              <h5 class="list-group-item-text ordListTxt">{{ OrdList.mx | currentDate(OrdList.mx) }}</h5>
              <h5 class="list-group-item-text ordListTxt">{{ OrdList.mw | schdType(OrdList.mw) }}</h5>
              <h5 class="list-group-item-text ordListTxt">{{ OrdList.ez }}</h5>
              <h5 class="list-group-item-text ordListTxt">{{ OrdList.y }}</h5>
              <h5
                v-if="OrdList.fi>0"
                class="list-group-item-text txtClrRed"
                style="font-size:20px;margin:0px;"
              >{{$t('cancelled')}}</h5>
              <h4
                class="list-group-item-text"
                style="float:right; font-size:20px;color:red;"
              >RM {{ OrdList.oj | currency(OrdList.oj)}}</h4>
            </div>
          </v-card>
        </div>
      </div>

      <div v-if="emptyOrderListHistory">
        <div>
          <h2 style="margin:30px">{{$t('NoOrderListRecord')}}</h2>
        </div>
      </div>
    </v-container>
    <v-container v-if="ordListDetail" style="padding:0px;">
      <div>
        <a @click="backToOrdListHistory()">
          <v-icon style="font-size:30px;padding-left:2.5px;padding-top:2px;">arrow_back</v-icon>
        </a>
      </div>
      <div v-if="errorTranId == false">
        <div class="col-xs-12">
          <div class="list-group-item">
            <h3 class="TrnHdr" style="overflow-wrap: break-word;font-size:16px;">{{orderRefNo}}</h3>
            <h3 class="TrnHdr" style="font-size:16px;">{{fullSchdDate}} {{fullSchdTime}}</h3>
            <h3 class="TrnHdr" style="font-size:16px;">{{$t('OrderType')}} : {{schdType}}</h3>
            <h3
              v-if="deleteTime>0"
              class="list-group-item-text txtClrRed"
              style="font-size:20px;margin:0px;"
            >{{$t('cancelled')}}</h3>
          </div>
          <br />

          <!-- <hr style="border:1px solid"> -->
          <div class="list-group-item">
            <h3
              class="TrnHdr"
              style="overflow-wrap: break-word;font-size:16px;"
            >{{$t('Name')}} : {{custName}}</h3>
            <h3
              v-if="custEmail != ''"
              class="TrnHdr"
              style="overflow-wrap: break-word;font-size:16px;"
            >{{$t('Email')}} : {{custEmail}}</h3>
            <h3 class="TrnHdr" style="font-size:16px;">{{$t('PhoneNo')}} : {{custPhNo}}</h3>
            <h3 v-if="custPax>0" style="font-size:16px;" class="TrnHdr">{{$t('Pax')}} : {{custPax}}</h3>
            <h3
              v-if="custAddress != ''"
              style="overflow-wrap: break-word;font-size:16px;"
              class="TrnHdr"
            >{{$t('Address')}} : {{custAddress}}</h3>
            <h3
              v-if="custMemo != ''"
              class="TrnHdr"
              style="overflow-wrap: break-word;font-size:16px;"
            >{{$t('Memo')}} : {{custMemo}}</h3>
          </div>
          <br />
          <!-- <hr style="border:1px solid"> -->
          <div class="list-group-item clearfix">
            <span style="float: right; min-width:65%;text-align:right;"></span>
            <span style="float: right; min-width:25%;text-align:right;">
              <strong>RM</strong>
            </span>
            <span style="float: right; min-width:10%;text-align:right;">
              <strong>{{$t('Qty')}}</strong>
            </span>
          </div>
          <div class="col-xs-12" style="padding:0px;">
            <a v-for="x of listOfTrnDtl" :key="x.ID" class="list-group-item clearfix">
              <div class="col-xs-12 pull-left" style="padding: 0;">
                <img style="float: left; max-width:15%;margin-right:10px;" :src="x.imgSmall" />
                <h5
                  v-if="x.size != '#' "
                  class="list-group-item-text itemDetails"
                  style="min-width:65%;font-size:16px;"
                >
                  {{ x.prdtName }}
                  <!-- ( {{ x.size }} ) -->
                  <span
                    style="float: right; min-width:25%;text-align:right;"
                  >{{ x.amount.toFixed(2) }}</span>
                  <span style="float: right; min-width:10%;text-align:right;">{{x.qty}}</span>
                </h5>

                <h5
                  v-if="x.size == '#' "
                  class="list-group-item-text itemDetails"
                  style="min-width:65%;font-size:16px;"
                >
                  {{ x.prdtName }}
                  <span
                    style="float: right; min-width:25%;text-align:right;"
                  >{{ x.amount.toFixed(2) }}</span>
                  <span style="float: right; min-width:10%;text-align:right;">{{x.qty}}</span>
                </h5>
                <!-- <h4 class="list-group-item-text">Quantity : {{ x.qty }}</h4>
                <h4 class="list-group-item-text">Amount : {{ x.amount.toFixed(2) }}</h4>-->
                <h5 class="list-group-item-text itemDetails" style="font-size:16px;">{{ x.memo }}</h5>
                <h5
                  class="list-group-item-text itemDetails"
                  style="font-size:16px;"
                >{{ x.propList }}</h5>
                <h5
                  v-if="x.deleteTime>0"
                  class="list-group-item-text"
                  style="float:right;font-size:18px;color:red;"
                >{{ $t('cancelled') }}</h5>
              </div>
            </a>
            <!-- <hr style="border:1px solid"> -->
          </div>
          <br />

          <div class="col-xs-12" style="padding:0px;">
            <div class="list-group-item clearfix">
              <span style="float: right; min-width:150px;text-align:right;">
                <strong>RM</strong>
              </span>
            </div>

            <div class="list-group-item clearfix">
              <h3 class="TrnHdr" style="font-size:16px;">
                {{$t('SubTotal')}} :
                <span style="float: right; ">{{subtotal.toFixed(2)}}</span>
              </h3>
              <h3 v-if="SvcAmt != 0" class="TrnHdr" style="font-size:16px;">
                {{$t('ServiceCharge')}} :
                <span style="float: right; ">{{SvcAmt.toFixed(2)}}</span>
              </h3>
              <h3 v-if="TaxAmt != 0" class="TrnHdr" style="font-size:16px;">
                {{$t('Tax')}} :
                <span style="float: right; ">{{TaxAmt.toFixed(2)}}</span>
              </h3>
              <h3 v-if="DeliveryChg != 0" class="TrnHdr" style="font-size:16px;">
                {{$t('DeliveryCharges')}} :
                <span style="float: right; ">{{DeliveryChg.toFixed(2)}}</span>
              </h3>
              <hr style="border:0.5px solid gainsboro" />

              <h2 class="grandTotal" style="font-size:20px;">
                {{$t('Total')}} :
                <span style="float: right; ">RM {{roundAmt.toFixed(2)}}</span>
              </h2>
              <hr style="border:0.5px solid gainsboro; margin-top:10px; margin-bottom:10px;" />
              <hr style="border:0.5px solid gainsboro; margin-top:10px; margin-bottom:10px;" />
              <h2 class="grandTotal" style="font-size:20px;">
                {{$t('PaidAmt')}} :
                <span style="float: right; ">RM {{paidAmt.toFixed(2)}}</span>
              </h2>
              <hr style="border:0.5px solid gainsboro; margin-top:10px; margin-bottom:10px;" />
              <hr style="border:0.5px solid gainsboro; margin-top:10px; margin-bottom:10px;" />
            </div>
            <!-- <hr style="border:1px solid"> -->
          </div>
        </div>
      </div>

      <div v-if="errorTranId">
        <h2 style="margin:15px;" class="errorTxt">{{$t('OrderListDetailRecordNotFound')}}</h2>
      </div>
    </v-container>
    <!-- </v-layout> -->
    <VersionDialog v-if="versionError"></VersionDialog>
  </v-app>
</template>

<script>
// import $ from 'jquery'
import JS from './JsonService'
import VersionDialog from '../src/VersionNotMatchDialog'
export default {
  components: {
    VersionDialog
  },
  filters: {
    currency(amount) {
      const amt = Number(amount)
      return amt.toFixed(2)
    },
    currentDate(date) {
      // console.log(date)
      const date1 = new Date(date).toString().substring(0, 24)
      // console.log(date1)
      return date1
    },
    schdType(type) {
      let btnName = JSON.parse(sessionStorage.getItem('SchdTypeBtnName'))
      if (type == 1) {
        if (btnName.DineIn == '') {
          return 'Dine In, Pre-order'
        } else {
          return btnName.DineIn
        }
      } else if (type == 2) {
        if (btnName.TakeAway == '') {
          return 'Take Away'
        } else {
          return btnName.TakeAway
        }
      } else if (type == 3) {
        if (btnName.Delivery == '') {
          return 'Delivery'
        } else {
          return btnName.Delivery
        }
      } else if (type == 4) {
        if (btnName.ScanOrder == '') {
          return 'Dine In, Scan, Order'
        } else {
          return btnName.ScanOrder
        }
      }
    }
  },
  data() {
    return {
      mCode: '',
      emptyOrderListHistory: true,
      ListOfOrderListHistory: [],
      versionError: false,
      ordListDetail: false,
      errorTranId: false,
      orderRefNo: '',
      fullSchdDate: '',
      fullSchdTime: '',
      schdType: '',
      deleteTime: 0,
      custName: '',
      custEmail: '',
      custPhNo: '',
      custAddress: '',
      custMemo: '',
      custPax: 0,
      listOfTrnDtl: [],
      subtotal: 0,
      SvcAmt: 0,
      TaxAmt: 0,
      roundAmt: 0,
      paidAmt: 0,
      DeliveryChg: 0
    }
  },
  created() {
    this.emptyOrderListHistory = true
    //get Order List History
    this.getOrdListHistory()
  },
  destroyed() {
    console.log('destroy')
  },
  methods: {
    getOrdListHistory() {
      this.versionError = false
      let mchCode = sessionStorage.getItem('backendMchCode')
      var version = sessionStorage.getItem('version')
      const url = 'Order/PurchaseHistory'
      const parameter = {
        av: version,
        kp: mchCode,
        m: 0
      }
      console.log('parameter: ', parameter)

      JS.request(url, parameter)
        .then(response => {
          console.log('data : ', response.data)
          if (
            response.data == '@#=#@@=$#9@=$#Version Not Match@=$#0' ||
            response.data == 'Version Not Match'
          ) {
            this.versionError = true
          } else {
            this.versionError = false
            if (response.data.ListOfTrnHdr.length > 0) {
              this.emptyOrderListHistory = false
              this.ListOfOrderListHistory = response.data.ListOfTrnHdr
            } else {
              this.emptyOrderListHistory = true
            }
          }
        })
        .catch(error => {
          this.versionError = false
          console.log(error)
        })
    },
    viewOrder(eorderId) {
      console.log(eorderId)
      if (eorderId == '' || eorderId == null || eorderId == undefined) {
        this.ordListDetail = false
        this.errorTranId = true
      } else {
        this.ordListDetail = true
        window.scrollTo(0, 0)
        this.errorTranId = false
        this.getOrdListDetail(eorderId)
      }
    },
    getOrdListDetail(tranId) {
      this.versionError = false
      var version = sessionStorage.getItem('version')
      let url = 'Order/ViewOrder'
      let para = {
        av: version,
        ml: tranId
      }
      JS.request(url, para)
        .then(res => {
          console.log('res', res.data)
          if (
            res.data == '@#=#@@=$#9@=$#Version Not Match@=$#0' ||
            res.data == 'Version Not Match'
          ) {
            this.versionError = true
          } else {
            this.versionError = false
            if (res.data.ListOfTrnHdr) {
              this.orderRefNo = ''
              this.fullSchdDate = ''
              this.fullSchdTime = ''
              this.schdType = ''
              this.deleteTime = 0
              this.custName = ''
              this.custEmail = ''
              this.custPhNo = ''
              this.custAddress = ''
              this.custMemo = ''
              this.custPax = 0
              this.SvcAmt = 0
              this.TaxAmt = 0
              this.DeliveryChg = 0
              this.roundAmt = 0
              this.paidAmt = 0
              this.getListOfTrnHdr(res.data.ListOfTrnHdr[0])
              this.getListOfTrnDtl(res.data.ListOfTrnDtl)
            } else {
              console.log(res.data)
              this.errorToken = true
            }
          }
        })
        .catch(err => {
          console.log('err', err)
          this.versionError = false
          alert(err)
          // this.$store.dispatch("updateValidState", 2)
        })
    },
    getListOfTrnHdr(data) {
      this.orderRefNo = data.oa
      this.fullSchdDate = new Date(data.mx)
        .toLocaleDateString('en-GB')
        .substr(0, 10)
      this.fullSchdTime = new Date(data.mx).toLocaleTimeString()
      let btnName = JSON.parse(sessionStorage.getItem('SchdTypeBtnName'))
      if (data.mw == 1) {
        if (btnName.DineIn == '') {
          this.schdType = 'Dine In, Pre-order'
        } else {
          this.schdType = btnName.DineIn
        }
      } else if (data.mw == 2) {
        if (btnName.TakeAway == '') {
          this.schdType = 'Take Away'
        } else {
          this.schdType = btnName.TakeAway
        }
      } else if (data.mw == 3) {
        if (btnName.Delivery == '') {
          this.schdType = 'Delivery'
        } else {
          this.schdType = btnName.Delivery
        }
      } else if (data.mw == 4) {
        if (btnName.ScanOrder == '') {
          this.schdType = 'Dine In, Scan, Order'
        } else {
          this.schdType = btnName.ScanOrder
        }
      }
      this.deleteTime = data.fi
      this.custName = data.ez
      this.custEmail = data.ly
      this.custPhNo = data.y
      this.custMemo = data.dy
      this.custAddress = data.en
      this.custPax = data.ot
      this.SvcAmt = data.oh
      this.TaxAmt = data.og
      this.DeliveryChg = data.rs
      this.roundAmt = data.oj
      this.paidAmt = data.lh
    },
    getListOfTrnDtl(data) {
      this.listOfTrnDtl = []
      this.subtotal = 0
      console.log(data.length)
      for (let i = 0; i < data.length; i++) {
        if (data[i].kw == '') {
          var defaultImg = require('./assets/ImgNotFound.png')
          data[i].kw = defaultImg
        } else {
          data[i].kw = JS.checkImg(data[i].kw)
        }
        const ListOfPrdDetail = {
          qty: data[i].lo,
          prdtName: data[i].ll,
          amount: data[i].lt,
          size: data[i].lm,
          memo: data[i].ln,
          imgSmall: data[i].kw,
          propList: data[i].lm,
          deleteTime: data[i].fi
        }
        this.subtotal += ListOfPrdDetail.amount
        this.listOfTrnDtl.push(ListOfPrdDetail)
      }
      console.log(this.subtotal)
      console.log(this.listOfTrnDtl)
    },
    backToOrdListHistory() {
      this.ordListDetail = false
      this.errorTranId = false
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style>
.ordListTxt {
  font-size: 14px;
  margin: 0px;
}
</style>
